import Vue from 'vue'

// axios
import axios from 'axios'
import { apiDashboardUrl, tenant } from '@/constants/config'
import { attachAuthRequestInterceptor, attachAuthResponseInterceptor } from '@/libs/authToken'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'http://mng.localhost:8000/api/',
  baseURL: apiDashboardUrl,
  headers: {
    'X-tenant': tenant,
  },
  // timeout: 1000,
})

attachAuthRequestInterceptor(axiosIns)
attachAuthResponseInterceptor(axiosIns)

Vue.prototype.$http = axiosIns

export default axiosIns
